import React from 'react';
export function Results() {
  return <section className="py-[60px] px-5 bg-brand-dark2" data-id="element-253">
      <div className="max-w-[860px] mx-auto" data-id="element-254">
        <h2 className="text-[clamp(22px,4vw,36px)] font-black text-white mb-3 text-center" data-id="element-255">
          Lo Que Vas a Lograr en 21 Días
        </h2>

        <table className="w-full border-collapse rounded-xl overflow-hidden" data-id="element-256">
          <thead data-id="element-257">
            <tr className="bg-brand-red" data-id="element-258">
              <th className="p-3.5 px-4.5 text-sm font-bold text-white text-left" data-id="element-259">
                Día
              </th>
              <th className="p-3.5 px-4.5 text-sm font-bold text-white text-left" data-id="element-260">
                Lo que habrás logrado
              </th>
            </tr>
          </thead>
          <tbody data-id="element-261">
            <tr className="even:bg-white/5" data-id="element-262">
              <td className="p-3.5 px-4.5 text-sm border-t border-brand-border text-brand-yellow font-bold" data-id="element-263">
                Día 3
              </td>
              <td className="p-3.5 px-4.5 text-sm border-t border-brand-border text-[#cdd9e5]" data-id="element-264">
                Todas tus deudas clasificadas — sabes exactamente con qué
                trabajas
              </td>
            </tr>
            <tr className="even:bg-white/5" data-id="element-265">
              <td className="p-3.5 px-4.5 text-sm border-t border-brand-border text-brand-yellow font-bold" data-id="element-266">
                Día 5
              </td>
              <td className="p-3.5 px-4.5 text-sm border-t border-brand-border text-[#cdd9e5]" data-id="element-267">
                Gastos invisibles cancelados — $50–$200 liberados sin cambiar tu
                ingreso
              </td>
            </tr>
            <tr className="even:bg-white/5" data-id="element-268">
              <td className="p-3.5 px-4.5 text-sm border-t border-brand-border text-brand-yellow font-bold" data-id="element-269">
                Día 9
              </td>
              <td className="p-3.5 px-4.5 text-sm border-t border-brand-border text-[#cdd9e5]" data-id="element-270">
                Calendario de pagos activo — nunca más un late fee por olvido
              </td>
            </tr>
            <tr className="even:bg-white/5" data-id="element-271">
              <td className="p-3.5 px-4.5 text-sm border-t border-brand-border text-brand-yellow font-bold" data-id="element-272">
                Día 10
              </td>
              <td className="p-3.5 px-4.5 text-sm border-t border-brand-border text-[#cdd9e5]" data-id="element-273">
                Al menos una deuda renegociada — fees eliminados, APR reducido
              </td>
            </tr>
            <tr className="even:bg-white/5" data-id="element-274">
              <td className="p-3.5 px-4.5 text-sm border-t border-brand-border text-brand-yellow font-bold" data-id="element-275">
                Día 21
              </td>
              <td className="p-3.5 px-4.5 text-sm border-t border-brand-border text-[#cdd9e5]" data-id="element-276">
                Control real — sin pánico al revisar tu cuenta bancaria
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>;
}